const init = () => {
    return class R_Tool extends createjs.Container {
        constructor(cm, w, h) {
            super();

            this.CODMOS = cm;

            this.setBounds(0, 0, w, h);

            this._w = w;
            this._h = h;

            this.addGameOver();
            this.addTimer();
        }

        /**
         * [ Function :: addGameOver ]
         *
         * @DES :: 게임 오버 객체 생성
         * @O.P :: null
         */
        addGameOver () {
            this._gameOver = new createjs.Bitmap(this.CODMOS._res.gameover._result);

            this._setCenter(this._gameOver);

            this._gameOver.visible = false;

            this.addChild(this._gameOver);
        }

        /**
         * [ Function :: onGameOver ]
         *
         * @DES :: 게임 오버 객체 출력
         * @O.P :: null
         */
        onGameOver () {
            this._gameOver.visible = true;
        }

        addTimer () {
            this._timer = new createjs.Container();
            this._timer.visible = false;

            const text = '';
            const style = '150px \'Yanolja\', sans-serif';

            this._timerText = new createjs.Text(text, style, 'white');
            this._timerBG = new createjs.Text(text, style, 'black');

            this._timerText.textAlign = 'left'
            this._timerBG.textAlign = 'left'

            this._timerText.textBaseline = 'middle'
            this._timerBG.textBaseline = 'middle'

            this._timerBG.outline = 2;

            this._timer.addChild(this._timerText);
            this._timer.addChild(this._timerBG);

            this.addChild(this._timer);
        }

        onTimer (cb) {
            this._timer.visible = true;

            let sec = 3;
            let interval;
            const func = () => {
                if (sec) {
                    this._timerText.text = sec;
                    this._timerBG.text = sec;

                    this._setCenter(this._timerText);
                    this._setCenter(this._timerBG);

                    sec--;
                } else {
                    clearInterval(interval);

                    this._timer.visible = false;
                    cb();
                }
            };
            func();
            interval = setInterval(func, 700);
        }

        _setCenter (obj) {
            const { width, height } = obj.getBounds();

            obj.x = this._w / 2 - width / 2;
            obj.y = this._h / 2 - height / 2;
        }
    };
};

export default init();



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/runner/dev/frame/R_Tool.js